import axios from 'axios';
import API_URLS from '../components/apiCalls/apiUrls';
const hostPath = process.env.REACT_APP_API_BASE_URL;
const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

export const getLoggedInUser = (val) => {
    const loggedInUser = localStorage.getItem(val);
    if (!loggedInUser) {
        console.error('No LoggedInUser found');
        return null;
    }
    try {
        const stateLoggedInUser = JSON.parse(loggedInUser);
        return stateLoggedInUser;
    } catch (error) {
        console.error('Error parsing LoggedInUser', error);
        return null;
    }
}
export const checkEmailExistence = async (email) => {
    const emailid = { EmailId: email };
    const requestOptions = {
        method: "POST",
        headers: { "x-functions-key": `${hostHeader}` },
        body: JSON.stringify(emailid),
    };
    try {
        const response = await axios.post(
            `${hostPath}${API_URLS.BASE_URL_CheckInternalEmployeeExist}`,
            requestOptions.body,
            { headers: requestOptions.headers }
        );
        if (response.data === true) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
    }
}
export const GetUserDetailsFromToken = async () => {
    try {
        const response = await fetch(`${hostPath}/api/GetUserDetailsFromToken`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
              },
            redirect: "follow"
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data; 
    } catch (error) {
        console.error('Failed to fetch users with valid employee IDs:', error);
        throw error;  
    }
};

